import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchasablePlanResponse, MembershipPlanResponse } from '../../models/response.module';
import { PaymentService } from '../../services/payment.service';
import { ToastService } from '../../../@core/services/toast.service';

@Component({
  selector: 'app-membership-purchase-modal',
  standalone: false,
  templateUrl: './membership-purchase-modal.html',
  styleUrl: './membership-purchase-modal.css'
})
export class MembershipPurchaseModal implements OnInit {
  @Input() itemName: string = '';
  @Input() basePrice: number = 0;
  @Input() currency: string = 'NOK';
  @Input() purchasablePlans: PurchasablePlanResponse[] = [];
  @Input() eventId: number | null = null;
  @Input() returnUrl: string = '';

  selectedPlan: MembershipPlanResponse | null = null;
  isPurchasing: boolean = false;

  constructor(
    private modal: NgbActiveModal,
    private paymentService: PaymentService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit() {
    console.log('MembershipPurchaseModal - purchasablePlans:', this.purchasablePlans);
    // Pre-select the first plan if available
    if (this.purchasablePlans.length > 0 && this.purchasablePlans[0].plan) {
      this.selectedPlan = this.purchasablePlans[0].plan;
      console.log('MembershipPurchaseModal - selectedPlan:', this.selectedPlan);
    }
  }

  selectPlan(plan: MembershipPlanResponse | null) {
    console.log('MembershipPurchaseModal - selectPlan called with:', plan);
    this.selectedPlan = plan;
  }

  getSelectedPlanDiscount(): PurchasablePlanResponse | null {
    if (!this.selectedPlan) return null;
    return this.purchasablePlans.find(p => p.plan?.plan_id === this.selectedPlan?.plan_id) || null;
  }

  formatPrice(priceCents: number): string {
    return (priceCents / 100).toFixed(2);
  }

  purchase() {
    if (!this.selectedPlan) {
      this.toastService.error('Please select a membership plan');
      return;
    }

    if (this.selectedPlan.plan_id === undefined || this.selectedPlan.plan_id === null) {
      console.error('Selected plan has no plan_id:', this.selectedPlan);
      this.toastService.error('Invalid membership plan selected');
      return;
    }

    this.isPurchasing = true;

    // Build success and cancel URLs
    const baseUrl = window.location.origin;
    const returnPath = this.returnUrl || `/event-registration/${this.eventId}`;
    const successUrl = `${baseUrl}${returnPath}?membership_payment=success`;
    const cancelUrl = `${baseUrl}${returnPath}?membership_payment=cancelled`;

    console.log('Creating membership checkout:', {
      plan_id: this.selectedPlan.plan_id,
      success_url: successUrl,
      cancel_url: cancelUrl
    });

    // Call payment service to create Stripe checkout session
    this.paymentService.createMembershipCheckout(
      this.selectedPlan.plan_id,
      successUrl,
      cancelUrl
    ).subscribe({
      next: (response) => {
        // Redirect to Stripe Checkout
        window.location.href = response.checkout_url;
      },
      error: (error) => {
        console.error('Failed to create membership checkout:', error);
        const errorMessage = error?.error?.reason || error?.error?.message || error?.message || 'Failed to start membership purchase';
        this.toastService.error(errorMessage);
        this.isPurchasing = false;
      }
    });
  }

  close() {
    this.modal.dismiss();
  }
}
